@if (display()) {
  <div class="td-wb-toolbar-container"
       [class.td-wb-toolbar-container--sticky]="menuSticky()"
       [class.td-wb-toolbar-container--modal]="modal()">
    <div class="td-wb-toolbar"
         role="toolbar"
         [class.td-wb-toolbar--sticky]="menuSticky()">
      <ng-content/>
    </div>
  </div>
}
